export default class VideoPlayer extends HTMLElement {
  get video() {
    return this.querySelector('video');
  }

  get autoplay() {
    return this.getAttribute('data-autoplay') === 'true';
  }

  connectedCallback() {
    this.initEvents();
  }

  initEvents() {
    this.addEventListener('click', this.playVideo.bind(this));

    if (this.autoplay) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.playVideo();
              observer.unobserve(this);
            } else {
              this.pauseVideo();
            }
          });
        },
        {
          threshold: 0.1,
        }
      );
      observer.observe(this.video);
    }
  }

  playVideo() {
    if (this.video) this.video.play();
  }

  pauseVideo() {
    if (this.video) this.video.pause();
  }
}

if (!customElements.get('video-player')) {
  customElements.define('video-player', VideoPlayer);
}
